





import { basicStrengthTitle } from '../../../src_server/entity/master/basicStrengthData';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({ components: {} })
export default class ClassBasicStrengthLevelPanel extends Vue {
  @Prop({ default: '' })
  private value!: string;

  get model() {
    return this.value;
  }

  set model(value: string) {
    this.$emit('input', value);
  }

  get options() {
    return Object.keys(basicStrengthTitle).map((item) => {
      return { title: basicStrengthTitle[item], value: item };
    });
  }
}
